module.exports = __webpack_public_path__ + "static/media/wechat.f8487e9c.svg";